export default {
  settings: {},
  translations: {},
}
